import { ArrowRight, BookOpen, Presentation, Sparkles, UserRoundCheck, Wrench } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SectionShell } from "./SectionShell";

/**
 * AI 関連の入口。
 *
 * 主眼はあくまで経営コンサルなので、他の節より大きくしない・目立たせない
 * （オーナー指示 2026-09-10「こそっとやるのだ」「均等でいい」）。
 * 文言は各ページが既に持っているものをそのまま引く。ここで新しく書かない。
 */
const ITEMS: { to: string; titleKey: string; bodyKey: string; icon: ReactNode }[] = [
  {
    to: "/ai-support",
    titleKey: "ai_support.page_title",
    bodyKey: "ai_support.hero_subtitle",
    icon: <UserRoundCheck aria-hidden="true" focusable="false" />,
  },
  {
    to: "/seminar",
    titleKey: "seminar.hero_title",
    bodyKey: "seminar.hero_subtitle",
    icon: <Presentation aria-hidden="true" focusable="false" />,
  },
  {
    to: "/ai-tools",
    titleKey: "ai_tools.page_title",
    bodyKey: "ai_tools.page_subtitle",
    icon: <Wrench aria-hidden="true" focusable="false" />,
  },
  {
    to: "/ai-glossary",
    titleKey: "ai_glossary.title",
    bodyKey: "ai_glossary.subtitle",
    icon: <BookOpen aria-hidden="true" focusable="false" />,
  },
];

/** ai_support.page_title は「AI顧問サービス | 社名（…）」形式。見出しには社名より前だけ使う。 */
const titleOnly = (value: string) => value.split("|")[0].trim();

export const AiSection = () => {
  const { t } = useTranslation();

  return (
    <SectionShell
      id="ai"
      icon={<Sparkles aria-hidden="true" focusable="false" />}
      heading={t("ai_section.heading")}
    >
      <div className="plan-grid">
        {ITEMS.map(({ to, titleKey, bodyKey, icon }) => (
          <Link className="plan" key={to} to={to} data-reveal>
            {icon}
            <div>
              <h3>{titleOnly(t(titleKey))}</h3>
              <p>{t(bodyKey)}</p>
            </div>
            <span className="detail">
              {t("plans.detail")}
              <ArrowRight aria-hidden="true" focusable="false" />
            </span>
          </Link>
        ))}
      </div>
    </SectionShell>
  );
};
